<script>
    import smokeMeta from './data/smoke/smoke.json';
    import SmokeMap from './lib/SmokeMap.svelte';
    import SmokeLegend from './lib/SmokeLegend.svelte';
    import { formatET, formatRunTime } from './utils/formatTime';

    let { width, data } = $props();

    const frames = smokeMeta.frames;
    const validDate = formatRunTime(new Date(smokeMeta.runTimeUTC));

    let frameIndex = $state(0);
    let playing = $state(true);
    let ready = $state(false);

    const validLabel = $derived.by(() => {
        const f = frames[frameIndex];
        return f?.validUTC ? formatET(new Date(f.validUTC)) : '';
    });

    function toggle() {
        playing = !playing;
    }
</script>

<div class="legend-slot">
    <SmokeLegend />
</div>

<figure class="smoke-map">
    <SmokeMap {width} bind:frameIndex bind:playing bind:ready showStateLabels={true} />

    <div class="controls">
        <button
            type="button"
            class="play"
            onclick={toggle}
            disabled={!ready}
            aria-label={playing ? 'Pause' : 'Play'}
        >
            {#if playing}
                <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="5" width="4" height="14" /><rect x="14" y="5" width="4" height="14" /></svg>
            {:else}
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5l12 7-12 7z" /></svg>
            {/if}
        </button>

        <div class="progress" aria-hidden="true">
            <div class="progress-fill" style="width: {(frameIndex / (frames.length - 1)) * 100}%"></div>
        </div>

        <span class="label">{validLabel}</span>
    </div>

    <p class="note">Forecasts as of {validDate}</p>
</figure>

<style lang="scss">
    .smoke-map {
        margin: 0;
        width: 100%;
    }

    .legend-slot {
        margin-bottom: 0.75rem;
    }

    .controls {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        margin-top: 0.75rem;
    }

    .play {
        flex: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 2rem;
        height: 2rem;
        padding: 0;
        border: none;
        border-radius: 50%;
        background: #262626;
        color: #ffffff;
        cursor: pointer;

        &:disabled {
            opacity: 0.4;
            cursor: default;
        }

        svg {
            width: 1rem;
            height: 1rem;
            fill: currentColor;
        }
    }

    .progress {
        flex: 1;
        height: 4px;
        border-radius: 2px;
        background: #e6e6e6;
        overflow: hidden;
    }

    .progress-fill {
        height: 100%;
        background: #262626;
        transition: width 0.15s linear;
    }

    .label {
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
        color: #404040;
    }

    .note {
        position: relative;
        display: table-cell;
        margin-bottom: 0;
        font-size: 12px;
        font-weight: normal;
        color: #8c8c8c;
        vertical-align: middle;
    }
</style>
